<template>
  <div>
    <Modal v-model="infoModal" width="1000" footer-hide>
      <div class="private-cloud-resource-detail-content">
        <div class="main" style="padding: 0">
          <div>
            <Row>
              <Col :xs="24" :sm="24" :md="24" :lg="24">
                <div>
                  <Alert v-if="infoError" type="warning" show-icon>获取端口详情数据失败</Alert>
                  <div class="info-property port-detail-content" v-else style="border: none; box-shadow: none;">
                    <dl>
                      <dt>ID</dt><dd>{{ info.id }}</dd>
                    </dl>
                    <dl>
                      <dt>端口名称</dt><dd>{{ info.name }}</dd>
                    </dl>
                    <dl>
                      <dt>网络ID</dt><dd>{{ info.network_id }}</dd>
                    </dl>
                    <dl>
                      <dt>MAC地址</dt><dd>{{ info.mac_address }}</dd>
                    </dl>
                    <dl>
                      <dt>状态</dt>
                      <dd v-if="info.status === 'ACTIVE'">运行</dd>
                      <dd v-else-if="info.status === 'DOWN'">不可用</dd>
                      <dd v-else-if="info.status === 'BUILD'">构建中</dd>
                      <dd v-else-if="info.status === 'ERROR'">错误</dd>
                      <dd v-else>{{ info.status }}</dd>
                    </dl>
                    <dl>
                      <dt>管理状态</dt>
                      <dd v-if="info.admin_state_up"><span>是</span></dd>
                      <dd v-else><span>否</span></dd>
                    </dl>
                    <dl>
                      <dt>开启端口安全性</dt>
                      <dd v-if="info.port_security_enabled"><span>是</span></dd>
                      <dd v-else><span>否</span></dd>
                    </dl>
                    <dl>
                      <dt>DNS名称</dt>
                      <dd>{{ info.dns_name }}</dd>
                    </dl>
                    <dl>
                      <dt>DNS指派</dt>
                      <dd v-if="info.dns_assignment">
                        <p><b>主机名：</b>{{ info.dns_assignment.hostname }}</p>
                        <p><b>IP地址：</b>{{ info.dns_assignment.ip_address }}</p>
                        <p><b>FQDN：</b>{{ info.dns_assignment.fqdn }}</p>
                      </dd>
                    </dl>
                    <dl>
                      <dt>固定IP</dt>
                      <dd style="padding-top: 8px">
                        <Row v-for="(item, index) in info.fixed_ips" :key="'fixed_ips_' + index">
                          <Alert style="font-size: 13px; line-height: 20px; background-color: #fff; border: 1px dashed rgb(230, 230, 230)">
                            <p><span>子网ID：</span>{{ item.subnet_id }}</p>
                            <p><span>IP地址：</span>{{ item.ip_address }}</p>
                          </Alert>
                        </Row>
                      </dd>
                    </dl>
                    <dl>
                      <dt>连接设备</dt>
                      <dd v-if="info.device_id">
                        <Alert style="font-size: 13px; line-height: 20px; background-color: #fff; border: 1px dashed rgb(230, 230, 230)">
                          <p><span>设备ID：</span>{{ info.device_id }}</p>
                          <p><span>设备所属者：</span>{{ info.device_owner }}</p>
                        </Alert>
                      </dd>
                    </dl>
                    <dl>
                      <dt>绑定</dt>
                      <dd>
                        <Alert style="font-size: 13px; line-height: 20px; background-color: #fff; border: 1px dashed rgb(230, 230, 230)">
                          <p><span>VNIC类型：</span>{{ info.binding_vnic_type }}</p>
                          <p><span>主机：</span>{{ info.binding_host_id }}</p>
                          <p><span>VIF类型：</span>{{ info['binding:vif_type'] }}</p>
                          <div>
                            <span>VIF详情：</span>
                            <div v-if="info['binding:vif_details']" style="padding-left: 30px">
                              <p v-for="(vifDetailValue, vifDetailKey, vifDetailIndex) in info['binding:vif_details']"
                                 :key="'vifDetailIndex_' + vifDetailIndex">{{ vifDetailKey }}：{{ vifDetailValue }}</p>
                            </div>
                          </div>
                        </Alert>
                      </dd>
                    </dl>
                    <dl>
                      <dt>创建时间</dt><dd v-if="info.created_at">{{ moment(info.created_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                    </dl>
                    <dl>
                      <dt>更新时间</dt><dd v-if="info.updated_at">{{ moment(info.updated_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                    </dl>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import moment from 'moment'
import { detailPrivateCloudPort } from '@/api/private-cloud/port'
export default {
  name: 'port-detail',
  data () {
    return {
      infoModal: false,
      infoError: false,
      info: {},
      moment: moment
    }
  },
  methods: {
    getInfo (id) {
      detailPrivateCloudPort(id).then(res => {
        this.infoError = false
        this.info = res.data.port
        this.infoModal = true
      }).catch(res => {
        this.infoError = true
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../base.less';
  .port-detail-content {
    max-height: 700px;
    overflow-y: auto;
  }
  .port-detail-content::-webkit-scrollbar {
    width: 5px;
  }
  .port-detail-content::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .port-detail-content::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
